import { mapGetters } from 'vuex'
import Microcart from '@vue-storefront/core/compatibility/components/blocks/Microcart/Microcart'

export const CartSummary = {
  name: 'CartSummary',
  mixins: [Microcart],
  computed: {
    ...mapGetters({
      totals: 'cart/getTotals',
      serviceFee: 'cart/getServiceFee',
      isVirtualCart: 'cart/isVirtualCart',
      paymentDetails: 'checkout/getPaymentDetails',
      ipayFee: 'ipay-payment-user/getFee',
      isFeeLoading: 'ipay-payment-user/isFeeLoading'
    }),
    isCheckoutPage () {
      return this.$route.name === 'checkout'
    },
    hasServiceFee() {
      return (this.serviceFee && this.serviceFee > 0)
    },
    isFeeAdded () {
      return this.paymentDetails && ['ipay_masterpass', 'ipay_applepay', 'ipay_gpay'].includes(this.paymentDetails.paymentMethod)
    },
    getDeliveryPrice () {
      return this.group.final_delivery
    },
    subtotal () {
      let subtotal = 0;
      this.getGroupedByPartnerProducts.forEach(group => {
        subtotal += group.subtotal
      })
      return subtotal
    }
  },
  watch: {
    totals () {
      if (this.loadingTotals) {
        setTimeout(() => {
          this.loadingTotals = false
        }, 1000)
      }
    }
  }
}
